export class AlertFilters {
  sicCd: string = '';
  exceptionType: string = '';
  region: string = '';
}
